module.exports = __webpack_public_path__ + "img/bizreach-logo-color.99a382d8.png";